import { plugToRequest } from 'react-cookies'

export const CLOUDFRONT_BASE_URL = `https://d3gievmnjacng1.cloudfront.net`
// export const CLOUDFRONT_BASE_URL = `https://maya-b2b.s3.eu-central-1.amazonaws.com`

export const CLIENT_STYLINGS = {
  bootz: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/bootz/images/MayaAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#5f6368',
      PRIMARY: '#004B41',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F7F7F7',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F7F7F7',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#FF9127',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#647183',
      BORDER: '#E0E5EA',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: "'Poppins', sans-serif",
      PRIMARY: "'Poppins', sans-serif",
    },
  },
  andersreizen: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/andersreizen/images/MayaAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#5f6368',
      PRIMARY: '#03392e',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F5F6F9',
      SECONDARY_FOREGROUND: '#425b76',
      ASSISTANT: '#F7F7F7',
      ASSISTANT_FOREGROUND: '#5f6368',
      USER: '#e0e0e0',
      USER_FOREGROUND: '#5f6368',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#647183',
      BORDER: '#E0E5EA',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: "'Poppins', sans-serif",
      PRIMARY: "'Poppins', sans-serif",
    },
  },
  consensio: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/consensio/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    BORDERS_ROUNDED: true,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#0494a4',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F5F5F5',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F5F5F5',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#0494a4',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#eaf0f6',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: 'Playfair Display, serif',
      PRIMARY: 'Raleway, sans-serif',
    },
  },
  tourtailors: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/tourtailors/images/MayaAvatar.svg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/tourtailors/images/PopoverChatAvatar.svg`,
    POPOVER_AVATAR_WIDTH_DESKTOP: '70px',
    POPOVER_AVATAR_HEIGHT_DESKTOP: '70px',
    POPOVER_AVATAR_WIDTH_MOBILE: '60px',
    POPOVER_AVATAR_HEIGHT_MOBILE: '60px',
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#4F5867',
      PRIMARY: '#f26e21',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F5F6F9',
      SECONDARY_FOREGROUND: '#425b76',
      ASSISTANT: '#F5F6F9',
      ASSISTANT_FOREGROUND: '#425b76',
      USER: '#f26e21',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#647183',
      BORDER: '#E0E5EA',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: 'Montserrat, sans-serif',
      PRIMARY: '"Open Sans", sans-serif',
    },
  },
  lifexperiences: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/lifexperiences/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    BORDERS_RADIUS: 0,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#ee8e06',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#ee8e06',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Montserrat", sans-serif',
      PRIMARY: '"Atlassian Sans", sans-serif',
    },
  },
  flytrip: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/flytrip/images/MayaAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'none',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'capitalize',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#0aad01',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#0aad01',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: "'Inter', sans-serif",
      PRIMARY: "'Inter', sans-serif",
    },
  },
  maya: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/maya/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#7B68F9',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#7B68F9',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"PT Sans", sans-serif',
      PRIMARY: '"PT Sans", sans-serif',
    },
  },
  bestarctic: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/bestarctic/images/MayaAvatar.jpg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/bestarctic/images/PopoverChatAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#4FA0A0',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#4FA0A0',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Asap", sans-serif',
      PRIMARY: '"Asap", sans-serif',
    },
  },
  holapola: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/holapola/images/MayaAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.5,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#88362F',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#88362F',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Carlito", sans-serif',
      PRIMARY: '"Carlito", sans-serif',
    },
  },
  plugplugtravel: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/plugplugtravel/images/MayaAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#31596a',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#31596a',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Poppins", sans-serif',
      PRIMARY: '"Poppins", sans-serif',
    },
  },
  zoover: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/zoover/images/MayaAvatar.png`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/zoover/images/PopoverChatAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_AVATAR_WIDTH_DESKTOP: '70px',
    POPOVER_AVATAR_HEIGHT_DESKTOP: '70px',
    POPOVER_AVATAR_WIDTH_MOBILE: '60px',
    POPOVER_AVATAR_HEIGHT_MOBILE: '60px',
    POPOVER_BOTTOM_DISTANCE: '45px',
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'capitalize',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFCF7',
      FOREGROUND: '#300837',
      PRIMARY: '#440B4E',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F7F2EF',
      SECONDARY_FOREGROUND: '#300837',
      ASSISTANT: '#FFF6EA',
      ASSISTANT_FOREGROUND: '#300837',
      USER: '#DED2FF',
      USER_FOREGROUND: '#000000',
      MUTED: '#FFFCF7',
      MUTED_FOREGROUND: '#574B59',
      BORDER: '#440D4E',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Afacad", sans-serif',
      PRIMARY: '"Afacad", sans-serif',
    },
  },
  neckermann: {
    POPOVER_CHAT_POSITION: 'left',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/neckermann/images/MayaAvatar.svg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/neckermann/images/PopoverChatAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_AVATAR_WIDTH_DESKTOP: '70px',
    POPOVER_AVATAR_HEIGHT_DESKTOP: '70px',
    POPOVER_AVATAR_WIDTH_MOBILE: '60px',
    POPOVER_AVATAR_HEIGHT_MOBILE: '60px',
    POPOVER_BOTTOM_DISTANCE: '70px',
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#660184',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#660184',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Raleway", "Mulish"',
      PRIMARY: '"Raleway", "Mulish"',
    },
  },
  bunkhouse: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/bunkhouse/images/MayaAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#FE875E',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#FE875E',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Aktiv",sans-serif',
      PRIMARY: '"Aktiv",sans-serif',
    },
  },
  emaar: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/emaar/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#061c35',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#061c35',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Ubuntu", sans-serif',
      PRIMARY: '"Ubuntu", sans-serif',
    },
  },
  travelbase: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '400px',
    POPOVER_DESKTOP_HEIGHT: '400px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/travelbase/images/MayaAvatar.svg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/travelbase/images/PopoverChatAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'none',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'none',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'none',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#3E6255',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#3E6255',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"sofia-pro",sans-serif',
      PRIMARY: '"filson-pro",sans-serif',
    },
  },
  joker: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/joker/images/MayaAvatar.png`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/joker/images/PopoverChatAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#d4592b',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#d4592b',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"museo slab", sans-serif',
      PRIMARY: '"museo sans", sans-serif',
    },
  },
  frenchmorning: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchmorning/images/MayaAvatar.svg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchmorning/images/PopoverChatAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_AVATAR_WIDTH_DESKTOP: '225px',
    POPOVER_AVATAR_HEIGHT_DESKTOP: '80px',
    POPOVER_AVATAR_WIDTH_MOBILE: '150px',
    POPOVER_AVATAR_HEIGHT_MOBILE: '60px',
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#d23f39',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#d23f39',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Oswald", sans-serif',
      PRIMARY: '"Montserrat", sans-serif',
    },
  },
  frenchmorningcanada: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchmorningcanada/images/MayaAvatar.svg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchmorningcanada/images/PopoverChatAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_AVATAR_WIDTH_DESKTOP: '225px',
    POPOVER_AVATAR_HEIGHT_DESKTOP: '80px',
    POPOVER_AVATAR_WIDTH_MOBILE: '150px',
    POPOVER_AVATAR_HEIGHT_MOBILE: '60px',
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#d23f39',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#d23f39',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Oswald", sans-serif',
      PRIMARY: '"Montserrat", sans-serif',
    },
  },
  frenchmorninglondon: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchmorninglondon/images/MayaAvatar.svg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchmorninglondon/images/PopoverChatAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_AVATAR_WIDTH_DESKTOP: '225px',
    POPOVER_AVATAR_HEIGHT_DESKTOP: '80px',
    POPOVER_AVATAR_WIDTH_MOBILE: '150px',
    POPOVER_AVATAR_HEIGHT_MOBILE: '60px',
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#d23f39',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#d23f39',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Oswald", sans-serif',
      PRIMARY: '"Montserrat", sans-serif',
    },
  },
  wikicampers: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/wikicampers/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#D4683E',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#D4683E',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: 'sans-serif',
      PRIMARY: 'sans-serif',
    },
  },
  isbjorn: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/isbjorn/images/MayaAvatar.png`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#000000',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#000000',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"DIN Pro", sans-serif',
      PRIMARY: '"DIN Pro", sans-serif',
    },
  },
  tripandstuff: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/tripandstuff/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#2d2d2d',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#2d2d2d',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Poppins", sans-serif',
      PRIMARY: '"Poppins", sans-serif',
    },
  },
  haystravel: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/haystravel/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#00437a',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#00437a',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: "'Open Sans'",
      PRIMARY: "'Open Sans'",
    },
  },
  dawsonandsanderson: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/dawsonandsanderson/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#669fb2',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#669fb2',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Mulish"',
      PRIMARY: '"Open Sans"',
    },
  },
  nazar: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/nazar/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#669fb2',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#669fb2',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Mulish"',
      PRIMARY: '"Open Sans"',
    },
  },
  aktiefski: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/aktiefski/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#565656',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#565656',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: 'Open Sans',
      PRIMARY: 'Open Sans',
    },
  },
  laplandtravel: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '600px',
    POPOVER_DESKTOP_HEIGHT: '600px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/laplandtravel/images/MayaAvatar.svg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/laplandtravel/images/PopoverChatAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#1f1f42',
      PRIMARY: '#1f1f42',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#0A0A15',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#1f1f42',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"sofia-pro",sans-serif',
      PRIMARY: '"sofia-pro",sans-serif',
    },
  },
  thegreenprogram: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/thegreenprogram/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#21d396',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#21d396',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Outfit",sans-serif',
      PRIMARY: '"Outfit",sans-serif',
    },
  },
  frenchly: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchly/images/MayaAvatar.svg`,
    POPOVER_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/frenchly/images/PopoverChatAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: true,
    POPOVER_AVATAR_WIDTH_DESKTOP: '200px',
    POPOVER_AVATAR_HEIGHT_DESKTOP: '250px',
    POPOVER_AVATAR_WIDTH_MOBILE: '100px',
    POPOVER_AVATAR_HEIGHT_MOBILE: '125px',
    POPOVER_CLOSE_WITH_AVATAR: false,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#2F5785',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#2F5785',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Canela"',
      PRIMARY: '"VisbyCF-Regular"',
    },
  },
  demo: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/demo/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#669fb2',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#669fb2',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: '"Mulish"',
      PRIMARY: '"Open Sans"',
    },
  },
  zuiderhuis: {
    POPOVER_CHAT_POSITION: 'right',
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/zuiderhuis/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.5,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#312220',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#312220',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: 'Source Sans Pro',
      PRIMARY: `Spectral, sans-serif`,
    },
  },
  levelovoyageur: {
    POPOVER_CHAT_POSITION: 'right',
    CHAT_BG_IMAGE: `${CLOUDFRONT_BASE_URL}/assets/levelovoyageur/images/ChatBgImage.png`,
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/levelovoyageur/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'none',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#A2BA0A',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#A2BA0A',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: 'Arial, Helvetica, sans-serif',
      PRIMARY: 'Helvetica',
    },
  },
  noorderhuis: {
    POPOVER_CHAT_POSITION: 'right',
    CHAT_BG_IMAGE: `${CLOUDFRONT_BASE_URL}/assets/noorderhuis/images/ChatBgImage.png`,
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/noorderhuis/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.5,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#2F5170',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#2F5170',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: 'Mulish',
      PRIMARY: 'Source Sans Pro',
    },
  },
  kingfisher: {
    POPOVER_CHAT_POSITION: 'right',
    CHAT_BG_IMAGE: `${CLOUDFRONT_BASE_URL}/assets/kingfisher/images/ChatBgImage.png`,
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/kingfisher/images/MayaAvatar.svg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'none',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'none',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#2297a7',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#2297a7',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: `'Lato', sans-serif`,
      PRIMARY: `'Lato', sans-serif`,
    },
  },
  odysseus: {
    POPOVER_CHAT_POSITION: 'right',
    CHAT_BG_IMAGE: `${CLOUDFRONT_BASE_URL}/assets/odysseus/images/ChatBgImage.png`,
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/odysseus/images/MayaAvatar.jpg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#333',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#333',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: 'Alegreya Sans SC',
      PRIMARY: 'Alegreya Sans SC',
    },
  },
  odysseus_b2b: {
    POPOVER_CHAT_POSITION: 'right',
    CHAT_BG_IMAGE: `${CLOUDFRONT_BASE_URL}/assets/odysseus_b2b/images/ChatBgImage.png`,
    POPOVER_MOBILE_HEIGHT: '475px',
    POPOVER_DESKTOP_HEIGHT: '500px',
    MAYA_AVATAR_URL: `${CLOUDFRONT_BASE_URL}/assets/odysseus_b2b/images/MayaAvatar.jpg`,
    POPVER_STICK_TO_BOTTOM: false,
    POPOVER_CLOSE_WITH_AVATAR: true,
    BORDERS_RADIUS: 0.75,
    GRID_ITEMS_TITLE_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_LOCATION_TEXT_TRANSFORM: 'uppercase',
    GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM: 'capitalize',
    COLOR: {
      BACKGROUND: '#FFFFFF',
      FOREGROUND: '#000000',
      PRIMARY: '#333',
      PRIMARY_FOREGROUND: '#FFFFFF',
      SECONDARY: '#F3F3F3',
      SECONDARY_FOREGROUND: '#000000',
      ASSISTANT: '#F3F3F3',
      ASSISTANT_FOREGROUND: '#000000',
      USER: '#333',
      USER_FOREGROUND: '#FFFFFF',
      MUTED: '#F6F6F6',
      MUTED_FOREGROUND: '#919191',
      BORDER: '#D9D9D9',
      DESTRUCTIVE: '#E41C1C',
      DESTRUCTIVE_FOREGROUND: '#FFFFFF',
    },
    FONTS: {
      SECONDARY: 'Alegreya Sans SC',
      PRIMARY: 'Alegreya Sans SC',
    },
  },
}

export const FONT_WEIGHT = {
  LIGHT: '300',
  NORMAL: '400',
  SEMIBOLD: '600',
  BOLD: '700',
}

export const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  mobileXL: '575px',
  tablet: '768px',
  laptop: '1025px',
  laptopL: '1440px',
  desktop: '2560px',
}

export const BannerActivitySize = {
  mobile: '334px',
  desktop: '200px',
  desktopInPixels: 200,
}
